import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import { format } from "date-fns-tz";
import { useEffect, useState } from "react";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto/static/Roboto-Regular.ttf",
});
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 35,
    paddingHorizontal: 35,
    margin: 0,
  },
  container: {
    flexDirection: "row",
    marginBottom: 3,
  },
  column: {
    flexGrow: 1,
    marginRight: 10,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },

  fieldName: {
    color: "grey",
    fontSize: 8,
  },
  fieldValue: {
    fontSize: 10,
    color: "black",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    width: "auto",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_No: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Ts: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Or: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Name: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
    fontFamily: "Roboto",
  },
  tableCell_A: {
    width: "6%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Kgs: {
    width: "7%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Up: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Amt: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Tkgs: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Tamt: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Remarks: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  sectionHeader: {
    fontWeight: "bold",
    color: "red",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 2,
  },
});

export default function SalesSummaryPrint({
  type,
  records,
  date,
  dateto,
  profile,
}) {
  const retailDataPrint = records?.summary_retail?.retail_data;
  const wholesaleDataPrint = records?.summary_ws?.ws_data;
  const outletDataPrint = records?.summary_outlet?.outlet_data;



  return (
    <Document>
      <Page size={"LETTER"} style={styles.body} orientation="portrait">
        <Text style={styles.header} fixed>
          K-GAZ
        </Text>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Prepared By:{" "}
              <Text
                style={styles.fieldValue}
              >{`${profile.firstName} ${profile.lastName}`}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Date:{" "}
              <Text style={styles.fieldValue}>
                {date} - {dateto}
              </Text>
            </Text>
          </View>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Print timestamp:{" "}
              <Text style={styles.fieldValue}>
                {format(new Date(), "yyyy-MM-dd HH:mm:ss", {
                  timeZone: "Asia/Manila",
                })}
              </Text>
            </Text>
          </View>
        </View>

        <View style={{ marginBottom: 15 }}>
          <Text style={styles.sectionHeader}>Retail</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text>Size</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text>Total Kilos Sold</Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text>Total Tanks Sold</Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text>Total Amount in Peso</Text>
              </View>
            </View>

            {retailDataPrint.map((productRetail, index) => (
              <View key={index} style={styles.tableRow}>
                <View style={styles.tableCell_No}>
                  <Text>{productRetail.prod_size}</Text>
                </View>
                <View style={styles.tableCell_Ts}>
                  <Text>{productRetail.total_sold}</Text>
                </View>
                <View style={styles.tableCell_Or}>
                  <Text>{productRetail.total_tank}</Text>
                </View>
                <View style={styles.tableCell_Name}>
                  <Text style={{ textAlign: "right" }}>
                    ₱{" "}
                    {Number(productRetail.total_amount).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </Text>
                </View>
              </View>
            ))}
             <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text style={{ fontWeight: "bold" }}>Grand Total</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text style={{ fontWeight: "bold" }}>
                  {retailDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_sold || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text style={{ fontWeight: "bold" }}>
                  {retailDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_tank || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text style={{ fontWeight: "bold", textAlign: "right" }}>
                  ₱{" "}
                  {retailDataPrint
                    .reduce(
                      (sum, item) => sum + Number(item.total_amount || 0),
                      0
                    )
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View style={{ marginBottom: 15 }}>
          <Text style={styles.sectionHeader}>Wholesale</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text>Size</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text>Total Kilos Sold</Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text>Total Tanks Sold</Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text>Total Amount in Peso</Text>
              </View>
            </View>

            {wholesaleDataPrint.map((productWS, index) => (
              <View key={index} style={styles.tableRow}>
                <View style={styles.tableCell_No}>
                  <Text>{productWS.prod_size}</Text>
                </View>
                <View style={styles.tableCell_Ts}>
                  <Text>{productWS.total_sold}</Text>
                </View>
                <View style={styles.tableCell_Or}>
                  <Text>{productWS.total_tank}</Text>
                </View>
                <View style={styles.tableCell_Name}>
                  <Text style={{ textAlign: "right" }}>
                    ₱{" "}
                    {Number(productWS.total_amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
              </View>
            ))}

            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text style={{ fontWeight: "bold" }}>Grand Total</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text style={{ fontWeight: "bold" }}>
                  {wholesaleDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_sold || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text style={{ fontWeight: "bold" }}>
                  {wholesaleDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_tank || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text style={{ fontWeight: "bold", textAlign: "right" }}>
                  ₱{" "}
                  {wholesaleDataPrint
                    .reduce(
                      (sum, item) => sum + Number(item.total_amount || 0),
                      0
                    )
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View style={{ marginBottom: 15 }}>
          <Text style={styles.sectionHeader}>Outlet</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text>Size</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text>Total Kilos Sold</Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text>Total Tanks Sold</Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text>Total Amount in Peso</Text>
              </View>
            </View>

            {outletDataPrint.map((productOutlet, index) => (
              <View key={index} style={styles.tableRow}>
                <View style={styles.tableCell_No}>
                  <Text>{productOutlet.prod_size}</Text>
                </View>
                <View style={styles.tableCell_Ts}>
                  <Text>{productOutlet.total_sold}</Text>
                </View>
                <View style={styles.tableCell_Or}>
                  <Text>{productOutlet.total_tank}</Text>
                </View>
                <View style={styles.tableCell_Name}>
                  <Text style={{ textAlign: "right" }}>
                    ₱{" "}
                    {Number(productOutlet.total_amount).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </Text>
                </View>
              </View>
            ))}
               <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text style={{ fontWeight: "bold" }}>Grand Total</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text style={{ fontWeight: "bold" }}>
                  {outletDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_sold || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text style={{ fontWeight: "bold" }}>
                  {outletDataPrint.reduce(
                    (sum, item) => sum + Number(item.total_tank || 0),
                    0
                  )}
                </Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text style={{ fontWeight: "bold", textAlign: "right" }}>
                  ₱{" "}
                  {outletDataPrint
                    .reduce(
                      (sum, item) => sum + Number(item.total_amount || 0),
                      0
                    )
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
